import {
  ReferenceType as ApiReferenceType,
  RefundInterface,
  RefundReason as ApiReason,
  RefundStatus as ApiStatus,
} from '@vendasta/billing';

export interface Refund {
  merchantId: string;
  chargeId: string;
  refundId: string;
  amount: number;
  reason: RefundReason;
  status: RefundStatus;
  created?: Date;
  updated?: Date;
  referenceType: ReferenceType;
  referenceId: string;
  description: string;
}

export enum RefundReason {
  REQUESTED_BY_CUSTOMER = 'Requested by Customer',
  DUPLICATE = 'Duplicate',
  FRAUDULENT = 'Fraudulent',
  UNKNOWN = 'Unknown',
}

export enum RefundStatus {
  SUCCEEDED = 'Succeeded',
  FAILED = 'Failed',
  PENDING = 'Pending',
  UNKNOWN = 'Unknown',
}

export enum ReferenceType {
  PURCHASE = 'Purchase',
  PURCHASE_ITEM = 'Purchase Item',
  INVOICE = 'Invoice',
  UNKNOWN = 'Unknown',
}

export function reasonToApi(r: RefundReason): ApiReason {
  switch (r) {
    case RefundReason.REQUESTED_BY_CUSTOMER:
      return ApiReason.REQUESTED_BY_CUSTOMER;
    case RefundReason.FRAUDULENT:
      return ApiReason.FRAUDULENT;
    case RefundReason.DUPLICATE:
      return ApiReason.DUPLICATE;
    default:
      return ApiReason.DUPLICATE;
  }
}

export function reasonFromApi(r: ApiReason | undefined): RefundReason {
  switch (r) {
    case ApiReason.DUPLICATE:
      return RefundReason.DUPLICATE;
    case ApiReason.REQUESTED_BY_CUSTOMER:
      return RefundReason.REQUESTED_BY_CUSTOMER;
    case ApiReason.FRAUDULENT:
      return RefundReason.FRAUDULENT;
    default:
      return RefundReason.REQUESTED_BY_CUSTOMER;
  }
}

export function statusFromApi(r: ApiStatus | undefined): RefundStatus {
  switch (r) {
    case ApiStatus.SUCCEEDED:
      return RefundStatus.SUCCEEDED;
    case ApiStatus.FAILED:
      return RefundStatus.FAILED;
    case ApiStatus.PENDING:
      return RefundStatus.PENDING;
    default:
      return RefundStatus.SUCCEEDED;
  }
}

export function referenceFromApi(r: ApiReferenceType | undefined): ReferenceType {
  switch (r) {
    case ApiReferenceType.PURCHASE:
      return ReferenceType.PURCHASE;
    case ApiReferenceType.PURCHASE_ITEM:
      return ReferenceType.PURCHASE_ITEM;
    case ApiReferenceType.INVOICE:
      return ReferenceType.INVOICE;
    default:
      return ReferenceType.PURCHASE;
  }
}

export function refundFromApi(refund: RefundInterface): Refund {
  return {
    merchantId: refund.merchantId || '',
    chargeId: refund.chargeId || '',
    refundId: refund.refundId || '',
    amount: refund.amount || 0,
    reason: reasonFromApi(refund.reason || undefined),
    status: statusFromApi(refund.status),
    created: refund.created ? new Date(refund.created) : undefined,
    updated: refund.updated ? new Date(refund.updated) : undefined,
    referenceType: referenceFromApi(refund.referenceType),
    referenceId: refund.referenceId || '',
    description: refund.description || '',
  };
}
